// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

import Layout from '@/layout';
var welfareRouter = {
  path: '/welfare',
  component: Layout,
  name: 'Welfare',
  meta: {
    title: '福利管理',
    icon: 'dashboard'
  },
  alwaysShow: true,
  children: [{
    path: 'project',
    component: function component() {
      return import('@/views/welfare/project/index');
    },
    name: 'project',
    meta: {
      title: '项目明细'
    }
  }, {
    path: 'cardDetail',
    component: function component() {
      return import('@/views/welfare/cardDetail/index');
    },
    name: 'cardDetail',
    meta: {
      title: '福卡明细'
    }
  }, {
    path: 'transactionDetail',
    component: function component() {
      return import('@/views/welfare/transactionDetail/index');
    },
    name: 'transactionDetail',
    meta: {
      title: '收支明细'
    }
  }]
};
export default welfareRouter;